exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ant-table-tbody .ant-table-row td[data-v-38b1b22c] {\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n#components-layout-demo-custom-trigger .trigger[data-v-38b1b22c] {\n  font-size: 18px;\n  line-height: 64px;\n  padding: 0 24px;\n  cursor: pointer;\n  -webkit-transition: color .3s;\n  transition: color .3s;\n}\n.item-info[data-v-38b1b22c] {\n  float:left;\n  width:30px;\n  height:30px;\n  margin-left:8px\n}\n.item-img[data-v-38b1b22c] {\n  cursor:pointer;\n  position: static;\n  display: block;\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n", ""]);

// exports
